import React from "react";

const Fingerprint = ({ ...rest }) => {
    return (
        <svg
            width="19"
            height="20"
            viewBox="0 0 19 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <path
                d="M3.80688 16.5304C3.82459 16.5005 3.84273 16.4709 3.8613 16.4413C5.2158 14.2881 5.99991 11.7418 5.99991 9C5.99991 6.79086 7.79077 5 9.99991 5C12.209 5 13.9999 6.79086 13.9999 9C13.9999 10.017 13.9307 11.0186 13.7966 12M11.6792 18.8436C12.2909 17.6226 12.7924 16.3369 13.1707 15M17.0097 16.132C17.6547 13.8657 18 11.4732 18 9C18 4.58172 14.4183 1 10 1C8.54285 1 7.17669 1.38958 6 2.07026M1 13.3641C1.64066 12.0454 2 10.5646 2 9C2 7.54285 2.38958 6.17669 3.07026 5M9.99987 9C9.99987 12.5172 8.99109 15.7988 7.24707 18.5712"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Fingerprint;
